import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { setPrefix } from '../../../utils/helpers';
import { LinkButtonProps } from '../../LinkButton/types';

export const StyledLink = styled(Link)`
  color: ${(props: any) => props.theme.linkColor};
  text-decoration: underline !important;
  font-family: ${(props: any) => props.theme.bodyFont};
  font-size: 0.875rem !important;
  font-weight: 800;

  &:hover {
    color: ${(props: any) => props.theme.linkColorHover};
  }
`;

export const StyledAnchor = styled.a`
  color: ${(props: any) => props.theme.linkColor};
  text-decoration: underline !important;
  font-family: ${(props: any) => props.theme.bodyFont};
  font-size: 0.875rem !important;
  font-weight: 800;

  &:hover {
    color: ${(props: any) => props.theme.linkColorHover};
  }
`;

const CTALink = (props: Partial<LinkButtonProps>) => {
  const { url, displayText } = props;

  return url?.startsWith('/') ? (
    <StyledLink
      to={url}
      data-component-type="link"
      className="trk-ga szl__link"
    >
      {displayText}
    </StyledLink>
  ) : (
    <StyledAnchor
      href={setPrefix(props.function, url)}
      data-component-type="link"
      className="trk-ga szl__link"
      target="_blank"
      rel="noreferrer"
    >
      {displayText}
    </StyledAnchor>
  );
};

export default CTALink;
